// components/Layout/Topbar/UserDropdown.jsx
import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import UserAvatar from "./UserAvatar";
import LogoutButton from "./LogoutButton";

const UserDropdown = ({ user, isOpen, setIsOpen, closeOthers }) => {
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, setIsOpen]);

  const toggleDropdown = () => {
    closeOthers();
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative ml-4" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-50 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <div className="text-right hidden sm:block">
          <div className="text-sm font-semibold text-gray-900">
            {user?.first_name} {user?.last_name}
          </div>
          <div className="text-xs text-gray-500">{user?.email}</div>
        </div>
        <UserAvatar user={user} showStatus={true} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-64 bg-white shadow-lg border border-gray-200 z-50">
          <div className="py-[1.125rem] px-[1.75rem] border-b border-gray-100 bg-[#f5f6fa]">
            <div className="flex items-center space-x-3">
              <UserAvatar user={user} showStatus={false} />
              <div>
                <div className="text-sm font-semibold text-gray-900">
                  {user?.first_name} {user?.last_name}
                </div>
                <div className="text-xs text-gray-500">{user?.email}</div>
              </div>
            </div>
          </div>
          
          <div className="border-t border-[#e5e9f2] px-[1.75rem]">
            <ul className="py-[0.75rem] mb-0">
              <li>
                <Link
                  to="/settings/profile"
                  className="flex items-center  text-sm text-[#526484] hover:bg-gray-50 transition-colors duration-150"
                >
                  Profile
                </Link>
              </li>
            </ul>
            
            
            
          </div>
          <div className="border-t border[#e5e9f2] px-[1.75rem]">
            <LogoutButton />
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;